import React, { useEffect, useState, useRef } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import useQuery from "../../hooks/useQuery";
import request from "../../network/request";

import { ISimpleVehicle, IVehicle } from "./type";
import {
  Params as UserVehicleListParams,
  Response as UserVehicleListReponse
} from "../../network/models/maintence/GetUserVehicleList";
import Loading from "../../components/loading";
import LoadingHomepage from "./components/LoadingHomepage";
import { ErrorPlaceholder } from "../../components/placeholder";
import { getCurrentVehicleInfoFromApp } from "../../utils/app";
import Fail from "./Fail";
import HomePageV2 from "./homepage/indexV2";
import EditingPage from "./EditingPage";
import SuccessV2 from "./success/indexV2";
import { formatVehiclePlate, desensitizedVin } from "../../utils/common";

import useGetCh from "../../hooks/useGetCh";
import useCurrentVeichle from "../../hooks/useVehicle";
import { reportUserBehavior } from "../../utils/report";
import { sendReport } from "../../utils/reporter";

// 专属售后门店
import ExclusiveStore from "../exclusive-store";

// 全局状态
import useBaseInfo from "./store/useBaseInfo";
import useGlobalInitData from "./store/useGlobalInitData";
import useBasicFormData from "./store/useBasicFormData";
import userVehicleList from "./store/useVehicleList";
import useCitiesData from "./store/useCitiesData";
import usePickupAddress from "./store/usePickupAddress";
import useSelfArrivalCity from "./store/useSelfArrivalCity";
import { TAB_ID_SET} from "./config/constants";

export default () => {
  const query = useQuery();
  const ch = useGetCh();
  const { currentVeichle } = useCurrentVeichle();
  const vinFromUrl = currentVeichle?.vin || query.get("vin");
  const platenumFromUrl = currentVeichle?.plateNumber || query.get("platenum");
  const {
    baseInfo,
    setVehicle,
    setReserveMan,
    setReserveTel,
    setSelectedVehicle,
    setEditingMode,
    setContentEdited
  } = useBaseInfo();
  const {
    setMergedInitData,
    setReserveGoingRecordDtoInitData,
    setReserveMaintainItemDtoInitData
  } = useGlobalInitData();
  
  // 提前获取数据
  const { error: citiesDataError, refreshAsync: refreshCitiesData } = useCitiesData();

  const { setVehicleList, vehicleListLoaded, setVehicleListLoaded } =
    userVehicleList();
  const { setPickupAddress } = usePickupAddress();
  const { setSelfArrivalCity } = useSelfArrivalCity();

  const {
    setStoreTimeTabIndex,
    setReserveItemsData,
    setContactInfoData,
    resetBasicInfoData
  } = useBasicFormData();

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const { path } = useRouteMatch();

  const reloadRef = useRef("");

  useEffect(() => {
    console.info(
      "初始化新流程中 Reservation initing ~~~~~~~~~~~~~~~~~~~~~~~~~~~~"
    );
    sendReport({
      mcode: "预约维保新建主页访问量",
      type: "page",
      point: "P11183`B006"
    });

    return () => {
      console.info("Reservation 卸载中 ~~~~~~~~~~~~~~~~~~~");
      setStoreTimeTabIndex(TAB_ID_SET.DATE_TAB);
      resetBasicInfoData();
      setVehicle("", "");
      setSelectedVehicle(null);
      setVehicleListLoaded(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 切换车辆时重置数据
  useEffect(() => {
    // console.info('初始化新流程中 reservation initing.... ~~11113334444444444444~~~~~~~~~~~~~~~~~~~~~~~~~~~~');
    if (baseInfo.frameNumber) {
      // 情况已选信息
      setPickupAddress({
        drivingPickupAddress: "",
        drivingPickupAddressLat: "",
        drivingPickupAddressLng: "",
        drivingPickupCityCode: "",
        drivingPickupCityName: ""
      });
      setSelfArrivalCity({ cityCode: 0, cityName: "" });
      doGetMaintainItemSingle();
      setStoreTimeTabIndex(TAB_ID_SET.DATE_TAB);
      setContentEdited(false);
      setEditingMode(false); // 编辑模式不可切换车牌，因此车牌变更，需要重置 editingMode

      // 重新获取数据
      doLoadingGlobalInitData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseInfo.frameNumber]);

  useEffect(() => {
    if (!vehicleListLoaded) {
      getUserVehicleAndList();
    }
    return () => {
      sessionStorage.setItem("__is_padded_specialService__", "no");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleListLoaded]);

  useEffect(() => {
    if (citiesDataError) {
      setIsError(true);
      setErrorMsg(citiesDataError.message);
    }
  }, [citiesDataError]);

  const doLoadingGlobalInitData = async () => {
    // 切换车辆是显示浮动的 Loading
    if (!isLoading) {
      Loading.show();
    }
    try {
      await getAllInitData();
    } catch(err) {
      throw err;
    } finally {
      setIsLoading(false);
      Loading.hide();
    }
  };

  const doGetMaintainItemSingle = async () => {
    getGlobalReserveMaintainItemDtoData();
  };

  const getAllInitData = async () => {
    return Promise.all([
      getGlobalMergedInitData(),
      getGlobalReserveGoingRecordDtoData()
    ]);
  };

  const getGlobalMergedInitData = async () => {
    try {
      const globalInitData: any = await request(
        "public/v2/module/maintenance/home/index",
        { vin: baseInfo.frameNumber },
        "POST",
        {
          useCustomUrl: true
        }
      );
      setMergedInitData(
        globalInitData?.userDefaultDto,
      );
      let contactMan = "";
      let contactPhone = "";
      if (globalInitData?.userDefaultDto?.contactMan) {
        contactMan = globalInitData?.userDefaultDto?.contactMan;
        setReserveMan(contactMan);
      }
      if (globalInitData?.userDefaultDto?.contactPhone) {
        contactPhone = globalInitData?.userDefaultDto?.contactPhone;
        setReserveTel(globalInitData?.userDefaultDto?.contactPhone);
      }
      // 填充步骤3数据
      setContactInfoData({
        contactName: contactMan,
        contactPhone: contactPhone
      });

      setReserveItemsData(globalInitData?.serviceItems);
    } catch (error) {
      reloadRef.current = "getGlobalInitData";
      setIsError(true);
      setErrorMsg((error as any).message || "加载数据失败，请稍后重试");
      throw error;
    }
  };

  const getGlobalReserveGoingRecordDtoData = async () => {
    try {
      const reserveGoingRecord: any = await request(
        "module/maintenance/reserveGoingRecord",
        { vin: baseInfo.frameNumber },
        "POST"
      );
      setReserveGoingRecordDtoInitData(reserveGoingRecord);
    } catch (error) {
      reloadRef.current = "getGlobalInitData";
      setIsError(true);
      setErrorMsg((error as any).message || "加载数据失败，请稍后重试");
      throw error;
    }
  };

  const getGlobalReserveMaintainItemDtoData = async () => {
    try {
      const res: any = await request(
        "module/maintenance/reserveAdviceAndMaintainItem",
        { vin: baseInfo.frameNumber },
        "POST"
      );
      setReserveMaintainItemDtoInitData(
        res?.reserveAdviceDto,
        res?.reserveMaintainItemDto,
        res?.maintainUrl || '',
        res?.smartMaintainActivated || false,
        res?.appVersion || null
      );
    } catch (error) {
      console.log(error);
      setReserveMaintainItemDtoInitData(
        null,
        null,
        '',
        false,
        null
      );
    }
  };

  const getUserVehicleAndList = async () => {
    try {
      let vehicleInfo: ISimpleVehicle = {
        label: "",
        platenum: "",
        vin: ""
      };
      let userVehicleList: IVehicle[];

      userVehicleList = await request<
        UserVehicleListParams,
        UserVehicleListReponse
      >("module/maintenance/vehicles", {});

      if (vinFromUrl !== null) {
        vehicleInfo = {
          platenum: platenumFromUrl || "",
          vin: vinFromUrl
        };
      } else {
        vehicleInfo = await getCurrentVehicleInfoFromApp();
      }

      console.log("vehicleInfo >>>>>>>>>>>>>>>>>>>>>>>>>>>>", vehicleInfo);

      let formatVehicleList: IVehicle[] = [];
      let matchingVehicle: IVehicle | null = null;
      // 判断用户车辆列表是否包含当前车辆(服务端已过滤为只包含主使用人及租客的车辆)
      if (Array.isArray(userVehicleList) && userVehicleList.length > 0) {
        formatVehicleList = userVehicleList.map((vehicle) => {
          return {
            ...vehicle,
            label: vehicle.plateNumber
              ? formatVehiclePlate(vehicle.plateNumber)
              : desensitizedVin(vehicle.vin)
            // vin: vehicle.vin,
            // plateNumber: vehicle.plateNumber,
          };
        });
        // 不包含则按下面规则：
        // 1. 优先取第一辆主使用人角色的车辆为默认车辆，
        // 2. 不存在主使用人角色的车辆则默认取第一辆车
        const matchVehicle = formatVehicleList.find(
          (item) => item.vin === vehicleInfo.vin
        );
        if (!matchVehicle) {
          const ownVehicle = formatVehicleList.find(
            (item) => item.userType === 1
          );
          if (ownVehicle) {
            matchingVehicle = ownVehicle;
            vehicleInfo = {
              label: ownVehicle.plateNumber
                ? formatVehiclePlate(ownVehicle.plateNumber)
                : desensitizedVin(ownVehicle.vin),
              platenum: ownVehicle.plateNumber || "",
              vin: ownVehicle.vin || "",
              vehicleSeriesNameCn: ownVehicle?.vehicleSeriesNameCn || ""
            };
          } else {
            matchingVehicle = formatVehicleList[0];
            vehicleInfo = {
              label: formatVehicleList[0].plateNumber
                ? formatVehiclePlate(formatVehicleList[0].plateNumber)
                : desensitizedVin(formatVehicleList[0].vin),
              platenum: formatVehicleList[0].plateNumber || "",
              vin: formatVehicleList[0].vin || ""
            };
          }
        } else {
          matchingVehicle = matchVehicle;
          vehicleInfo = {
            label: matchVehicle.plateNumber
              ? formatVehiclePlate(matchVehicle.plateNumber)
              : desensitizedVin(matchVehicle.vin),
            platenum: matchVehicle.plateNumber || "",
            vin: matchVehicle.vin || ""
          };
        }
        // setSelectedVehicle();
      }

      setVehicleList(formatVehicleList);
      setVehicle(vehicleInfo.vin, vehicleInfo.platenum);
      setSelectedVehicle(matchingVehicle);
      setVehicleListLoaded(true);
    } catch (error) {
      reloadRef.current = "getUserVehicleAndList";
      setIsLoading(false);
      setIsError(true);
      setErrorMsg((error as any).message || "加载数据失败，请稍后重试");
      setVehicleListLoaded(true);
      throw error;
    }
  };

  // 选中车辆变更
  useEffect(() => {
    if (!baseInfo.selectedVehicle) return;
    const { vin, plateNumber } = baseInfo.selectedVehicle;
    const { frameNumber } = baseInfo;
    if (vin && vin !== frameNumber) {
      setVehicle(vin, plateNumber);
    }
  }, [baseInfo, setVehicle]);

  const reloadData = async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      if (citiesDataError) {
        await refreshCitiesData();
      }
  
      if (reloadRef.current === "getUserVehicleAndList") {
        await getUserVehicleAndList();
      } else if (reloadRef.current === "getGlobalInitData") {
        await getAllInitData();
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (isError) {
    reportUserBehavior(
      {
        so: "J001005",
        mcode: "maintence",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={reloadData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <>
      <Switch>
        <Route exact path={`${path}`}>
          <HomePageV2 />
        </Route>
        <Route exact path={`${path}/edit/:reserveId`}>
          <EditingPage />
        </Route>
        <Route exact path={`${path}/success/:orderId`}>
          <SuccessV2 />
        </Route>
        <Route exact path={`${path}/fail`}>
          <Fail />
        </Route>
        {/* @deprecated */}
        <Route exact path={`${path}/exclusive`}>
          <ExclusiveStore />
        </Route>
      </Switch>
    </>
  );
};
